import React from 'react';
import { Link } from 'react-router-dom'; // assuming you are using React Router for navigation
import './Header.scss';

interface HeaderProps {
  pageTitle: string;
  breadcrumb: string;
}

const Header: React.FC<HeaderProps> = ({ pageTitle, breadcrumb }) => {
  return (
    <div className="header-container">
      <div className="breadcrumb">
        <Link to="/">SJM (Govt. Aided) Polytechnic</Link> {'>'} {breadcrumb}
      </div>
      <h1 className="page-title">{pageTitle}</h1>
    </div>
  );
};

export default Header;
